import { DisabledEditabilitySettings } from '../common/constants'

const DisabledDimensionEditableEdibilitySettings = {
  ...DisabledEditabilitySettings,
  customPropertyConfig: {
    dimensionEditable: false,
  },
}

const TextItemEdibilitySettings = {
  stylable: true,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
  customPropertyConfig: {
    dimensionEditable: false,
  },
}

const PlaceholderItemEdibilitySettings = {
  stylable: false,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
}

const NEXT_STEPS_DESIGN_FRAMES = [
  {
    component: {
      type: 'wrapper',
      ...DisabledDimensionEditableEdibilitySettings,
      propagate: [
        'stylable',
        'resizable',
        'editable',
        'locked',
        'hoverable',
        'selectable',
        'draggable',
        'droppable',
        'highlightable',
        'copyable',
        'badgable',
        'removable',
      ],
      components: [
        {
          tagName: 'div',
          type: 'FullScreen',
          classes: ['editor-editable-comp-fullscreen'],
          components: [
            {
              tagName: 'custompagelayout',
              type: 'CustomPageLayout',
              components: [
                {
                  tagName: 'twoequalcolumns',
                  type: 'TwoEqualColumns',
                  classes: ['next-steps__container', 'flexbox-2-columns'],
                  attributes: {},
                  components: [
                    {
                      classes: ['two-equal-columns__column', 'next-steps__stepper'],
                      attributes: {
                        id: 'next-steps__stepper',
                      },
                      components: [
                        {
                          tagName: 'stepper',
                          type: 'Stepper',
                          components: [
                            {
                              classes: ['stepper'],
                              components: [
                                {
                                  classes: ['stepper__step'],
                                  components: [
                                    {
                                      tagName: 'span',
                                      classes: ['stepper__count--active', 'undeleteable'],
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['body-1--medium', 'undeleteable'],
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '1',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['undeleteable'],
                                          style: {
                                            'font-size': '20px',
                                            'line-height': '28px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                          },
                                          ...TextItemEdibilitySettings,
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'Site Visit',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  classes: ['stepper__step'],
                                  components: [
                                    {
                                      tagName: 'span',
                                      classes: ['stepper__count', 'undeleteable'],
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['body-1--medium', 'undeleteable'],
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '2',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['undeleteable'],
                                          style: {
                                            'font-size': '20px',
                                            'line-height': '28px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                          },
                                          ...TextItemEdibilitySettings,
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'System Engineering',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  classes: ['stepper__step'],
                                  components: [
                                    {
                                      tagName: 'span',
                                      classes: ['stepper__count', 'undeleteable'],
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['body-1--medium', 'undeleteable'],
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '3',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['undeleteable'],
                                          style: {
                                            'font-size': '20px',
                                            'line-height': '28px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                          },
                                          ...TextItemEdibilitySettings,
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'Permitting',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  classes: ['stepper__step'],
                                  components: [
                                    {
                                      tagName: 'span',
                                      classes: ['stepper__count', 'undeleteable'],
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['body-1--medium', 'undeleteable'],
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '4',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['undeleteable'],
                                          style: {
                                            'font-size': '20px',
                                            'line-height': '28px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                          },
                                          ...TextItemEdibilitySettings,
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'Installation',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  classes: ['stepper__step'],
                                  components: [
                                    {
                                      tagName: 'span',
                                      classes: ['stepper__count', 'undeleteable'],
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['body-1--medium', 'undeleteable'],
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '5',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          classes: ['undeleteable'],
                                          style: {
                                            'font-size': '20px',
                                            'line-height': '28px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                          },
                                          ...TextItemEdibilitySettings,
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'Activation',
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      classes: ['two-equal-columns__column', 'next-steps__cover'],
                      attributes: {
                        id: 'next-steps__cover',
                      },
                      components: [
                        {
                          classes: ['full-width', 'next-steps__cover__house-model'],
                          tagName: 'house-model',
                          type: 'house-model',
                        },
                        {
                          classes: ['next-steps__cover__texts'],
                          components: [
                            {
                              classes: ['next-steps__cover__text-container'],
                              components: [
                                {
                                  tagName: 'p',
                                  type: 'text',
                                  classes: ['next-steps__cover__title'],
                                  style: {
                                    color: '#13171a',
                                    'font-size': '32px',
                                    'font-weight': 'bold',
                                    'letter-spacing': '-0.02em',
                                    'line-height': '56px',
                                    'text-align': 'center',
                                  },
                                  ...TextItemEdibilitySettings,
                                  components: [
                                    {
                                      type: 'textnode',

                                      content: 'Thank You',
                                    },
                                  ],
                                },
                                {
                                  tagName: 'placeholder',
                                  type: 'placeholder',
                                  classes: ['next-steps__cover__address'],
                                  ...PlaceholderItemEdibilitySettings,
                                  style: {
                                    color: '#62686e',
                                    'font-size': '20px',
                                    'font-weight': 'normal',
                                    'letter-spacing': '-0.02em',
                                    'line-height': '28px',
                                    'text-align': 'center',
                                  },
                                  attributes: {
                                    'data-placeholder': 'project.address',
                                    PLACEHOLDER_LABEL_OVERRIDE: '',
                                    id: 'i3jeri',
                                  },
                                },
                              ],
                            },
                            {
                              classes: ['next-steps__cover__text-container'],
                              components: [
                                {
                                  classes: ['next-steps__cover__pro-info'],
                                  components: [
                                    {
                                      tagName: 'p',
                                      type: 'text',
                                      ...TextItemEdibilitySettings,
                                      style: {
                                        color: '#000',
                                        'font-size': '16px',
                                        'font-weight': 'normal',
                                        'letter-spacing': '-0.02em',
                                        'line-height': '20px',
                                      },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: 'Prepared by: ',
                                        },
                                        {
                                          tagName: 'placeholder',
                                          type: 'placeholder',
                                          ...PlaceholderItemEdibilitySettings,
                                          classes: ['next-steps__cover__pro-info__placeholder'],
                                          attributes: {
                                            'data-placeholder': 'org.name',
                                            PLACEHOLDER_LABEL_OVERRIDE: '',
                                            id: 'i3qfzw',
                                          },
                                          component: {
                                            compare: null,
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'span',
                                      type: 'text',
                                      classes: ['next-steps__cover__pro-info__divider'],
                                      style: { color: '#d8dde3' },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: '|',
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'placeholder',
                                      type: 'placeholder',
                                      ...PlaceholderItemEdibilitySettings,
                                      classes: ['next-steps__cover__pro-info__placeholder'],
                                      attributes: {
                                        'data-placeholder': 'org.sales_phone_number',
                                        PLACEHOLDER_LABEL_OVERRIDE: '',
                                        id: 'i3yzez',
                                      },
                                      component: {
                                        compare: null,
                                      },
                                    },
                                    {
                                      tagName: 'span',
                                      type: 'text',
                                      classes: ['next-steps__cover__pro-info__divider'],
                                      style: { color: '#d8dde3' },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: '|',
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'placeholder',
                                      type: 'placeholder',
                                      ...PlaceholderItemEdibilitySettings,
                                      classes: [
                                        'next-steps__cover__pro-info__placeholder',
                                        'next-steps__cover__pro-info__email',
                                      ],
                                      style: { color: 'var(--Brand-Colors-Blue-900)' },
                                      attributes: {
                                        'data-placeholder': 'org.company_email',
                                        PLACEHOLDER_LABEL_OVERRIDE: '',
                                        id: 'i3hffq',
                                      },
                                      component: {
                                        compare: null,
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      head: {
        type: 'head',
      },
      docEl: {
        tagName: 'html',
      },
    },
    id: 'u9tP8J5TVwdy0s2C',
  },
]

export const NEXT_STEPS_PAGE_ID = 'go-next-steps'

export const NEXT_STEPS_PAGE_DESIGN = {
  frames: NEXT_STEPS_DESIGN_FRAMES,
  type: 'main',
  name: 'Go:Next Steps',
  id: NEXT_STEPS_PAGE_ID,
}
